import React, { useState } from 'react';

/**
 * Accordion simple reutilizable
 * Props:
 * - title: string
 * - children: contenido del acordeón
 * - defaultOpen: boolean (opcional)
 * - className: string (opcional)
 */
const Accordion = ({ title, children, defaultOpen = false, className = '' }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`border rounded-lg mb-2 bg-white dark:bg-gray-700 ${className}`}>
      <button
        type="button"
        className="w-full flex justify-between items-center px-4 py-3 font-semibold text-left focus:outline-none dark:text-white"
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
      >
        <span>{title}</span>
        <span className={`transform transition-transform duration-200 ${open ? 'rotate-90' : ''}`}>▶</span>
      </button>
      <div
        className={`transition-all duration-300 ${open ? 'max-h-[70vh] py-2 px-4 overflow-y-auto' : 'max-h-0 p-0 overflow-hidden'}`}
        aria-hidden={!open}
        style={{ minHeight: open ? undefined : 0 }}
      >
        {open && children}
      </div>
    </div>
  );
};

export default Accordion;
